module.exports = __webpack_public_path__ + "img/img2.100ecbf8.svg";